<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <mat-card>
    <mat-accordion multi="true" *ngIf="papers.length > 0 && !isLoading">
      <mat-expansion-panel *ngFor="let paper of papers">
        <mat-expansion-panel-header>
          <span>Name: <b>{{ paper.paperName }}</b></span>
        </mat-expansion-panel-header>
        <div class="d-flex flex-column flex-sm-row gap-3 w-100">
          <div class="d-flex flex-column gap-3 col-12 col-sm-6">
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light">
              {{ "Width: " }} <b>{{ paper.paperWidth }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light">
              {{ "Height: " }} <b>{{ paper.paperHeight }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light">
              {{ "Weight: " }} <b>{{ paper.paperWeight }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light">
              {{ "Printer Code: " }} <b>{{ paper.paperPrinterCode }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light">
              {{ "Printer Quality: " }} <b>{{ paper.paperPrinterQuality }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light text-green">
              {{ "is Express: " }} <b>{{ paper.isExpress }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light text-green">
              {{ "is Plotter: " }} <b>{{ paper.isPlotter }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light text-green">
              {{ "is Ph: " }} <b>{{ paper.isPh }}</b>
            </span>
          </div>
        </div>
        <mat-action-row>
          <a mat-button color="primary" [routerLink]="['/paperedit', paper.id]">EDIT</a>
          <button mat-button color="warn" (click)="onDelete(paper.id)">DELETE</button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    <p class="info-text mat-body-1" *ngIf="papers.length <= 0 && !isLoading">No papers added yet!</p>
    <div class="spacer"></div>
  </mat-card>
</div>

<div class="p-2">
  <mat-paginator class="m-0" [length]="totalPapers" [pageSize]="papersPerPage" [pageSizeOptions]="pageSizeOptions"
    (page)="onChangedPage($event)" *ngIf="papers.length > 0"></mat-paginator>
  <div class="pt-2">
    <button class="w-100 rounded-pill" mat-raised-button type="button" (click)="toPapersCreate()">
      Create a Paper
    </button>
  </div>
</div>